import { render, staticRenderFns } from "./IStatisticsPanel.vue?vue&type=template&id=e6c9b252&"
import script from "./IStatisticsPanel.vue?vue&type=script&lang=js&"
export * from "./IStatisticsPanel.vue?vue&type=script&lang=js&"
import style0 from "./IStatisticsPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QOptionGroup from 'quasar/src/components/option-group/QOptionGroup.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QCardSection,QOptionGroup,QBtn});
